const THEME_KEY = "pdp-theme";
const THEME_COLORS = Object.freeze({
  light: "#073f52",
  dark: "#071d26"
});

export function resolveTheme(storedTheme, prefersDark = false) {
  if (storedTheme === "light" || storedTheme === "dark") return storedTheme;
  return prefersDark ? "dark" : "light";
}

function storedTheme() {
  try {
    return globalThis.localStorage?.getItem(THEME_KEY);
  } catch {
    return null;
  }
}

export function currentTheme() {
  return resolveTheme(
    storedTheme(),
    globalThis.matchMedia?.("(prefers-color-scheme: dark)").matches
  );
}

export function applyTheme(theme = currentTheme()) {
  const resolved = resolveTheme(theme);
  document.documentElement.dataset.theme = resolved;
  document.documentElement.style.colorScheme = resolved;
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.content = THEME_COLORS[resolved];
  return resolved;
}

export function toggleTheme() {
  const next = currentTheme() === "dark" ? "light" : "dark";
  try {
    globalThis.localStorage?.setItem(THEME_KEY, next);
  } catch {
    // O tema ainda funciona durante a sessão quando o navegador bloqueia armazenamento.
  }
  return applyTheme(next);
}

export function themeLabel(theme = currentTheme()) {
  return theme === "dark" ? "Usar tema claro" : "Usar tema escuro";
}

export { THEME_KEY };
